import { Controller } from "@hotwired/stimulus"

// Captures geolocation when the user picks a photo, then submits the form.
// Acquiring at file-pick (not submit) keeps the controller out of the submit
// event entirely, so it does not race with ActiveStorage's direct_upload,
// which also fires submit events on its own schedule.
// Falls through gracefully — if geolocation is unavailable or denied, fields
// stay empty and the server-side fallback (IP) handles it.
export default class extends Controller {
  static targets = ["latitude", "longitude", "accuracy", "fixedAt", "permissionState"]

  async captureAndSubmit() {
    if (navigator.permissions) {
      try {
        const status = await navigator.permissions.query({ name: "geolocation" })
        this.permissionStateTarget.value = status.state
      } catch (e) {
        // Some browsers reject "geolocation" as a permission name
      }
    }

    if (navigator.geolocation) {
      const position = await this.acquire()
      if (position) {
        this.latitudeTarget.value = position.coords.latitude
        this.longitudeTarget.value = position.coords.longitude
        this.accuracyTarget.value = position.coords.accuracy
        this.fixedAtTarget.value = position.timestamp
      }
    }

    this.element.requestSubmit()
  }

  acquire() {
    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        resolve,
        () => resolve(null),
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
      )
    })
  }
}
